import { Card, CardContent } from "@/components/ui/card"
import { Skeleton } from "@/components/ui/skeleton"

/**
 * OKS-474 — §18 loading skeletons (UX Spec §3 — skeletons matching the
 * populated layout, NOT spinners). One per deferred section; rendered as the
 * Inertia `<Deferred>` fallback so the chrome paints instantly and each
 * section streams in behind a shape that matches its real content.
 */

/** Two greyed value-bars matching the stat tiles. */
export function CrewStatRowSkeleton() {
  return (
    <div data-testid="crew-stat-row-skeleton" className="flex gap-3 px-4">
      {[0, 1].map((i) => (
        <Card key={i} className="flex-1">
          <CardContent className="flex flex-col gap-2 px-4 py-3">
            <Skeleton className="size-5 rounded" />
            <Skeleton className="h-7 w-20" />
            <Skeleton className="h-3 w-16" />
          </CardContent>
        </Card>
      ))}
    </div>
  )
}

/** Header + three greyed leaderboard rows. */
export function ThisWeekLeadersSkeleton() {
  return (
    <Card data-testid="this-week-leaders-skeleton">
      <CardContent className="flex flex-col gap-2 px-4 py-3">
        <Skeleton className="h-3 w-32" />
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex items-center gap-3 px-3 py-2">
            <Skeleton className="size-4 rounded" />
            <Skeleton className="size-8 rounded-full" />
            <Skeleton className="h-4 flex-1" />
            <Skeleton className="h-4 w-12" />
          </div>
        ))}
      </CardContent>
    </Card>
  )
}

/** Header + a wrapping grid of greyed avatar cells. */
export function CrewRosterSkeleton() {
  return (
    <Card data-testid="crew-roster-skeleton">
      <CardContent className="flex flex-col gap-3 px-4 py-3">
        <Skeleton className="h-3 w-24" />
        <div className="flex flex-wrap gap-x-3 gap-y-4">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="flex w-16 flex-col items-center gap-1">
              <Skeleton className="size-12 rounded-full" />
              <Skeleton className="h-3 w-10" />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
